<template>
  <DefaultLayout>
    <template #buttons>
      <OfficeCreateAction @created="reload" v-if="can('COMPANY_MANAGE')" />
    </template>

    <OfficeFilter :filters="filters">
      <h1 class="h5 mt-2">
        {{ i18n('Offices') }}
        <span class="small text-muted" v-if="!pagination?.total">({{ offices.length }})</span>
        <span class="small text-muted" v-else>({{ pagination?.total }})</span>
      </h1>
      <template #buttons>
        <ExportToExcelAction cssClass="btn btn-sm btn-outline-dark ms-1" />
      </template>
    </OfficeFilter>

    <OfficeList :pagination="pagination" :offices="offices" :loading="loading" :autoLazyLoad="!!pagination.nextPageURI"
      @deleted="reload" @updating="loading = true" @updated="reload" @next="nextPage" @goToPage="goToPage" />
  </DefaultLayout>
</template>

<script>
import paginatedViewMixin from "@/mixins/common/paginatedViewMixin.js";
import api from "@/api.js";
import { canAccessPage } from "@/routeAcl.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import ExportToExcelAction from "@/components/common/actions/ExportToExcelAction.vue";
import OfficeCreateAction from "@/components/office/OfficeCreateAction.vue";
import OfficeFilter from "@/components/office/OfficeFilter.vue";
import OfficeList from "@/components/office/OfficeList.vue";

export default {
  mixins: [paginatedViewMixin,],
  components: {
    DefaultLayout,
    ExportToExcelAction,
    OfficeCreateAction,
    OfficeFilter,
    OfficeList,
  },
  data() {
    return {
      listPropertyName: 'offices',
      apiResource: `offices`,
      offices: [],
    }
  },
  mounted() {
    this.$root.setPageTitle(this.i18n('offices'));
    api.auth().then((user) => {
      this.$root.loggedUser = user;

      if (!user.loggedIn) {
        return; // Layout non-anonymous will handler redirect
      }

      if (!canAccessPage(this.$route?.name, user, this.$root.features)) {
        this.$router.push({ name: 'Index', });
        return;
      }

      this.load();
    });
  },
  watch: {
    params: {
      handler() {
        this.pagination.loadPages = 1;
        this.reload();
      },
      deep: true,
    },
  },
  methods: {
    extendApiParams(params) {
      params.acl = 'office';
    },
  },
};
</script>